<div class="ml-5">
  <div class="m-4">
    <p class="titre1">
      {{ 'AIDE_ET_SOUTIEN.NOTES_VERSION_SECTION.TITLE' | translate }}
      <mat-icon
      class="material-symbols-outlined text-[38px] w-[45px] h-[45px] mt-[5px] mr-[30px] float-right">history</mat-icon>
    </p>
    <p class="text-xl">
      {{ appVersionCourte }}
      @if (appBuild) {
        <span> ({{ appBuild }})</span>
      }
    </p>
  </div>

  @if (chargement) {
    <div class="flex justify-center items-center py-10">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  }

  @if (erreur && !chargement) {
    <div class="text-center py-10 text-red-600">
      <p>{{ 'AIDE_ET_SOUTIEN.NOTES_VERSION_SECTION.ERREUR_CHARGEMENT' | translate }}</p>
    </div>
  }

  @if (!chargement && !erreur) {
    <div class="container mx-auto px-4 pb-8">
      <div class="release-notes-content" [innerHTML]="contenuHtml"></div>
    </div>
  }
</div>
